<template>
  <div class="overview">
    <v-card flat>
      <v-card-text>
        <DataTable
          :optionsPassed="options"
          :totalEsvs="totalEsvs"
          :esvs="esvs"
          :searchPassed="search"
          :headerSelects="headerSelects"
          :headersTable="headersTable"
          v-on:getEsvs="getEsvs"
          :loading="loading"
          :allowIgnoreServiceLimitTIme="false"
          :showHasApproved="true"
        >
          <template #title>
            <v-icon left>mdi-filter</v-icon>
            Overview
          </template>
          <template #headerButtons>
            <v-btn
              color="success"
              class="mr-2"
              small
              v-if="$can('ExportToExcel', 'Overview')"
              @click="download"
              :loading="downloadLoading"
            >
              <v-icon left>mdi-export</v-icon>
              Export to Excel
            </v-btn>
          </template>
        </DataTable>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src
import { ExportType, StatusCode } from "@/enums";

import DataTable from "@/components/ESV/DataTable.vue";

// var searchTimeOut;

export default {
  name: "ToBeApproved",
  components: {
    DataTable,
  },
  data: () => ({
    esvs: [],
    search: [],
    options: { /*itemsPerPage: 15*/ },
    totalEsvs: null,
    headerSelects: [{ serviceRequestType: [] }, { status: [] }],
    headersTable: [
      {
        text: "Type",
        value: "serviceRequestType",
        type: "select",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Dossier",
        value: "esvReference",
        type: "text",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Description",
        value: "subject",
        type: "text",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Service Grade",
        value: "serviceGrade",
        type: "select",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Product Group",
        value: "productGroup",
        type: "select",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Approval Status",
        value: "approvalStatus",

        class: "text-subtitle-1 font-weight-bold",
      },
    ],
    loading: false,
    downloadLoading: false,
  }),
  computed: {},
  methods: {
    getEsvs(tableSearch) {
      this.loading = true;
      this.search = tableSearch.search;
      this.options = tableSearch.options;
      this.$api
        .getEsvsToBeApproved(tableSearch)
        .then((resp) => {
          this.esvs = resp.data.esvs;
          this.totalEsvs = resp.data.totalEsvs;
          // this.esvs = resp.data.esvs
          // this.totalEsvs = resp.data.totalEsvs
        })
        .finally(() => (this.loading = false));
    },
    download() {
      this.downloadLoading = true;
      this.$api
        .downloadOverview(ExportType.excel, StatusCode.toBeApproved, this.search, this.ignoreServiceLimitTime)
        .finally(() => (this.downloadLoading = false));
    },
  },

  mounted() {},

  watch: {},
};
</script>
